export default __webpack_public_path__ + "static/media/maple.side.texture.c83e7daf.webp";